import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { connect } from "react-redux";
import { deleteKeywordApi, getKeywordNameApi } from "./Api";
import { Col, Image, Row } from "react-bootstrap";

import editPencil from "../../assets/images/edit-icon.png";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import KeywordForm from "./KeywordForm";
import { ComponentHeader, InformationModal, IsVerified, VerifiedModal } from "../common";
import { MODULE_ID_MAP, START_PAGE, Trending, contentMaster, isModuleExist, subConternMaster, subTrending } from "../../utils/Constant";
import { KEYWORD_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { replaceHistory } from "../../utils/ReusableFunctions";
import { withRouter } from "../../utils/hoc/withRouter";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";
import { Tag } from "antd";
export class KeywordTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.TrendingKeywords);

    this.state = {
      access: AccesData,
      delete: false,
      listData2: '',
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: '',

      search: "",
    };
  }
  filterData = (isSort = false) => {

    const getData = this.props.masterCategoryState.listData;
    const sortedData = getData.list.sort((a, b) => {
      return (a.isVerified === b.isVerified ? 0 : a.isVerified ? 1 : -1);
    });
    this.setState({ listData2: sortedData });
  }
  // todo---------------------------------------.
  componentDidMount() {

    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getKeywordNameApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const search = params.get("search") || "";
    const verified = params.get("isVerified") || "";

    if (prevPage !== page || prevVerified !== verified || prevSearch !== search) {
      this.setState({ currentPage: page, listData2: '', search }, () => {
        this.props.getKeywordNameApi(this);

      });
    }
  }
  // todo:-----------------------------------------


  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteKeywordApi(id, this, this.openCloseDeleteModal)
  }
  onChangeMethod = (value) => {
    this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
      replaceHistory(this.props.history, START_PAGE, value.search)
    })
  };
  clearSearch = () => {
    this.onChangeMethod({ search: "" })
  }
  render() {
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    const { access, listData2 } = this.state;


    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.keyword} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.keyword}'`}
          show={this.state.show}
          url={KEYWORD_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getKeywordNameApi(this); }}
        />
        {
          this.state.showEdit &&
          <KeywordForm
            show={this.state.showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Keywords"
          isSearch={true}
          placeholder={"Search Keywords"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          primaryBtn={access.createAccess ? "Add keywords" : ""}
          handlePrimaryBtn={() => {

            this.setState({ showEdit: true })
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">

          <CustomTable
            data={listData2 || listData.list || []}
            columns={[
              {
                width: 250,
                title: "Keyword",
                dataIndex: "keyword",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return <span className="d-flex align-items-center gap-12"> {rowData.keyword}
                      {/* <IsVerified data={rowData}/>  */}
                    </span>;
                },
              },
              {
                width: 100,
                title: "Search Count",
                dataIndex: "searchCount",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.searchCount;
                },
              },
              {
                width: access.verificationAccess ? 130 : 0,
                title: "Verified",
                dataIndex: "verify",
                className: "name",
                isFilter: true,
                handleSortByCol: () => { this.filterData(true); },
                isCell: true,
                render:(text, rowData, dataKey) => {
                    const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.updatedBy?.name || 'Na';;
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.createdBy?.name || 'Na';
                },
              },

              {

                width: 20,
                title: "Action",
                dataIndex: "",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      <>
                        {/* {access.updateAccess && (
                          <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                        )}
                        {access.deleteAccess && (
                          <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                        )} */}

                        <OptionsDropdown
                          editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                          deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        />
                      </>
                    );
                },

              }


            ]}
            message="No data found" // For Pagination
            history={this.props.history}
            location={this.props.location}
            total={totalPages}
            currentPage={currentPage}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}
const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getKeywordNameApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(KeywordTab));
